import axios from "axios";
import { getEnvVariable, REACT_APP_API_URL } from "utils/environment";
import { retrieveTokenFromLocalStorage } from "services/utils/serviceutils";
import { HierarchyItemType } from "types/generic";

/* Gis Hierarchy controller */

export const getAllGisHierarchyItemsByHierarchyId = (hierarchyId: number) => {
    const url = `${getEnvVariable(
        REACT_APP_API_URL
    )}gisHierarchyItem/hierarchy/${hierarchyId}`;
    const config: any = {
        method: "get",
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
    };
    return axios(config);
};

export const createGisHierarchyItem = (hierarchyItem: HierarchyItemType) => {
    const url = `${getEnvVariable(REACT_APP_API_URL)}gisHierarchyItem/`;
    const config: any = {
        method: "post",
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
        data: hierarchyItem,
    };
    return axios(config);
};

export const deleteGisHierarchyItem = (hierarchyItemId: number) => {
    const url = `${getEnvVariable(
        REACT_APP_API_URL
    )}gisHierarchyItem/${hierarchyItemId}`;
    const config: any = {
        method: "delete",
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
    };
    return axios(config);
};

export const updateGisHierarchyItem = (hierarchyItem: HierarchyItemType) => {
    const url = `${getEnvVariable(REACT_APP_API_URL)}gisHierarchyItem/`;
    const config: any = {
        method: "put",
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
        data: hierarchyItem,
    };
    return axios(config);
};

export const addLayerToGisHierarchyItem = (itemId: number, layerId: number) => {
    const url = `${getEnvVariable(
        REACT_APP_API_URL
    )}gisHierarchyItem/hierarchy/${layerId}/${itemId}`;
    const config: any = {
        method: "post",
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
    };
    return axios(config);
};

export const deleteGisHierarchyLayer = (layerId: number) => {
    const url = `${getEnvVariable(
        REACT_APP_API_URL
    )}gisHierarchyItem/hierarchy/${layerId}`;
    const config: any = {
        method: "delete",
        url: url,
        headers: {
            Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
        },
    };
    return axios(config);
};

/* Gis Hierarchy controller */
